import { inject, Reactive } from 'vue';
import { IBetDialogRef } from '@/types';

export function useBetDialogsRefs() {
    return inject<Reactive<Record<string, IBetDialogRef>>>('betDialogsRefs');
}
